import { combineReducers } from '@reduxjs/toolkit';
import { reducer as storeReducer } from './stores.slice';

const reducer = combineReducers({
  stores: storeReducer,
});

export default reducer;
